/** 参謀くんのパートナーID。バックエンドの DataCollaborationPartner テーブルの固定値。 */
export const SAMBO_KUN_PARTNER_ID = 1;
